import React from 'react';
import './Reviews2.css';

const reviews = [
  {
    id: 1,
    name: "Arjun Patel",
    role: "Director, FinEdge Consulting",
    country: "India",
    rating: 5,
    service: "Tax Advisory",
    content: "Krinvy's tax advisory team saved us over ₹12 lakhs in the first year itself with their strategic planning. Their expertise in Indian tax laws is unparalleled.",
    avatar: "A"
  },
  {
    id: 2,
    name: "Jennifer Lopez",
    role: "CFO, RetailChain Inc.",
    country: "USA",
    rating: 4,
    service: "Inventory Management",
    content: "Their custom inventory solution reduced our stock discrepancies by 78%. The only reason for 4 stars is we'd like more frequent feature updates.",
    avatar: "J"
  },
  {
    id: 3,
    name: "Sanjay Gupta",
    role: "Founder, MedTech Innovations",
    country: "India",
    rating: 5,
    service: "Company Incorporation",
    content: "From name reservation to GST registration, Krinvy handled everything in just 7 days. Their compliance team is exceptionally responsive.",
    avatar: "S"
  },
  {
    id: 4,
    name: "Robert Chen",
    role: "Operations Head, TechBridge Solutions",
    country: "USA",
    rating: 5,
    service: "Cloud Migration",
    content: "Migrated our entire infrastructure to AWS with zero downtime. The engineers were available round-the-clock during the transition period.",
    avatar: "R"
  },
  {
    id: 5,
    name: "Meera Krishnan",
    role: "CEO, EduGrowth Academy",
    country: "India",
    rating: 5,
    service: "Learning Management System",
    content: "Our student engagement doubled after implementing their LMS platform. The analytics dashboard gives us incredible insights into learning patterns.",
    avatar: "M"
  },
  {
    id: 6,
    name: "Daniel Wilson",
    role: "Marketing Head, GreenEarth Organics",
    country: "USA",
    rating: 5,
    service: "E-commerce Development",
    content: "Our online sales grew by 300% after launching the new store they built. The checkout process is seamless and conversion-optimized.",
    avatar: "D"
  },
  {
    id: 7,
    name: "Priyanka Sharma",
    role: "Director, HR Solutions",
    country: "India",
    rating: 5,
    service: "HRMS Software",
    content: "From recruitment to payroll, their all-in-one HR platform has automated 90% of our processes. The mobile app is particularly impressive.",
    avatar: "P"
  },
  {
    id: 8,
    name: "Emily Parker",
    role: "CTO, DataInsights Corp",
    country: "USA",
    rating: 5,
    service: "Big Data Solutions",
    content: "Processed 2TB of raw data daily with their custom Hadoop solution. Query response times improved from hours to seconds.",
    avatar: "E"
  }
];

const Reviews2 = () => {
  return (
    <section className="kr-reviews2-section">
      <div className="kr-reviews2-container">
       

        <div className="kr-reviews2-scroll-wrapper">
          <div className="kr-reviews2-track-loop">
            {[...reviews, ...reviews].map((review, index) => (
              <div className="kr-review2-card" key={`${review.id}-${index}`}>
                <div className="kr-review2-header">
                  <div className="kr-review2-avatar">{review.avatar}</div>
                  <div className="kr-review2-user">
                    <h4 className="kr-review2-name">{review.name}</h4>
                    <p className="kr-review2-role">{review.role}, {review.country}</p>
                  </div>
                </div>
                <div className="kr-review2-service"><span>{review.service}</span></div>
                <div className="kr-review2-rating">
                  {"★".repeat(review.rating)}{"☆".repeat(5 - review.rating)}
                </div>
                <p className="kr-review2-text">{review.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews2;